import api from 'api'
import { Button, Icon, Tooltip } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { reportFormatDate, useHandleImpressao } from 'hooks/impressao/useHandleImpressao'
import { isEmpty } from 'util/checks'

import { MChatRfAccordionSection } from '../../components/MChatRfAccordionSection'
import { MChatRfAccordionStepper } from '../../components/MChatRfAccordionStepper'
import { MChatAccessDocLink } from '../../mchat/components/MChatAccessDocLink'
import { MChatRfAccordionSectionEnum } from '../../model-mChatRf'
import { ConsultaSeguimentoViewModel, ImpressaoConsultaSeguimento } from '../model-consultaSeguimento'

interface ConsultaSeguimentoViewProps {
  value: ConsultaSeguimentoViewModel
  isMChatRiscoMedio: boolean
}

export function ConsultaSeguimentoView(props: Readonly<ConsultaSeguimentoViewProps>) {
  const { value, isMChatRiscoMedio } = props

  const {
    cidadao: { id: cidadaoId },
  } = useAtendimentoContext()

  const { PILOTO_M_CHAT_RF_ENABLED } = useFlags()

  const hasValues = !isEmpty(value)

  const { handleImpressaoPath, handleImpressaoError } = useHandleImpressao<ImpressaoConsultaSeguimento>()

  const handlePrint = (value: ConsultaSeguimentoViewModel) => {
    const input: ImpressaoConsultaSeguimento = {
      atendProfId: value.footerInfo?.atendimentoProfissionalId,
      cidadaoId: cidadaoId,
      resultadoSeguimento: value.resultado,
      totalPerguntasRespondidas: value.totalPerguntasRespondidas,
      totalPerguntasFalhou: value.totalPerguntasFalhou,
      totalPerguntasPassou: value.totalPerguntasPassou,
    }

    handleImpressaoPath({
      apiPath: api.mchat.imprimirMChat,
      values: input,
      file: `MChat.pdf`,
      dateFormat: reportFormatDate,
    }).catch(handleImpressaoError)
  }

  return (
    <MChatRfAccordionSection
      section={MChatRfAccordionSectionEnum.CONSULTA_SEGUIMENTO}
      value={value}
      isConsultaSeguimentoAtiva={hasValues || isMChatRiscoMedio}
      primaryActions={!PILOTO_M_CHAT_RF_ENABLED && <MChatAccessDocLink />}
      stepper={
        <MChatRfAccordionStepper
          showPendingIcon={!hasValues && !isMChatRiscoMedio}
          showCheckIcon={hasValues}
          showConnector={false}
          showInfoIcon={!hasValues && isMChatRiscoMedio}
          showErrorIcon={false}
        />
      }
      secondaryActions={
        <Tooltip text='Imprimir'>
          <Button type='button' kind='normal' skin='ghost' size='small' onClick={() => handlePrint(value)}>
            <Icon icon='printerOutline' />
          </Button>
        </Tooltip>
      }
    />
  )
}
